import {Button, Checkbox, Container, FormControlLabel, TextareaAutosize, Typography, Grid} from '@material-ui/core';
import StatusView from 'ApplicationEntry/components/WorkFlow/AWDStatus/StatusForm';
import DisplayPolicyNumber from 'ApplicationEntry/components/WorkFlow/AWDStatus/DisplayPolicyNumber';
import UnderWriterView from 'ApplicationEntry/components/WorkFlow/AWDStatus/UnderwriterView';
import WorkTypeView from 'ApplicationEntry/components/WorkFlow/AWDStatus/WorkTypeView';
import * as AWDStatusActions from 'ApplicationEntry/ducks/AWDStatus';
import {AWDStatus} from 'ApplicationEntry/models/AWDStatus/AWDStatus';
import {isUnassignedUnderwriter} from 'ApplicationEntry/models/AWDStatus/Underwriter';
import {isUnassignedWorkType} from 'ApplicationEntry/models/AWDStatus/WorkType';
import {PolicyRecord} from 'ApplicationEntry/models/PolicyRecord';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import {isNonEmptyString} from 'Core/models/EmptyString';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './AWDStatus.sass';
import {OrdinaryAWDStatus} from 'ApplicationEntry/models/AWDStatus/OrdinaryAWDStatus';

type AWDStatusDashboardProps = {
  awdStatus: AWDStatus;
  policyRecord: PolicyRecord;
  workQueueItemList?: WorkQueueItem[];
  isQuality: boolean;
};

const AWDStatusDashboard = (props: AWDStatusDashboardProps) => {
  const dispatch = useDispatch();

  const {
    workTypeList,
    comments,
    comments2,
    comments3,
    workType,
    workType2,
    workType3,
    statusList,
    status,
    status2,
    status3,
    underwriterList,
    underwriter,
    underwriter2,
    underwriter3,
    override,
  } = props.awdStatus;
  const businessArea = props.policyRecord.businessArea;
  const workQueueItemList = props.workQueueItemList;

  useEffect(() => {
    if (isNonEmptyString(businessArea)) {
      if (isUnassignedWorkType(workTypeList)) {
        dispatch(AWDStatusActions.getWorkTypeList(businessArea.value));
      }
    }
  }, [businessArea, dispatch, workTypeList]);

  useEffect(() => {
    if (isUnassignedUnderwriter(underwriterList)) {
      dispatch(AWDStatusActions.getUnderwriterList());
    }
  }, [underwriterList, dispatch]);

  useEffect(() => {
    if (isNonEmptyString(businessArea) && isNonEmptyString(workType)) {
      dispatch(AWDStatusActions.getStatusList(businessArea.value, workType.value));
    }
  }, [workType, dispatch, businessArea]);

  const changeComment = (comment: string, idx: number) => {
    if (idx == 0) {
      dispatch(AWDStatusActions.changeComments(comment));
    } else if (idx == 1) {
      dispatch(AWDStatusActions.changeComments2(comment));
    } else if (idx == 2) {
      dispatch(AWDStatusActions.changeComments3(comment));
    }
  };

  const changeoverRide = (idx: number) => {
    if (idx == 0) {
      dispatch(AWDStatusActions.changeOverride());
    } else if (idx == 1) {
      dispatch(AWDStatusActions.changeOverride2());
    } else if (idx == 2) {
      dispatch(AWDStatusActions.changeOverride3());
    }
  };

  const getComment = (rowNo: number) => {
    if (rowNo == 0) {
      return comments.value;
    } else if (rowNo == 1) {
      return comments2.value;
    } else if (rowNo == 2) {
      return comments3.value;
    }
  };

  return (
    <div className="awdStatus-section__dialog " id="awdStatus-section__dialog">
      <Container
        className="awdStatus-section__dialog-container "
        id="awdStatus-section__dialog-container"
        maxWidth={false}
      >
        <form noValidate autoComplete="off" className="awdStatus-section">
          <div className="awdStatus-section__title-container">
            <Typography variant="subtitle1" className="awdStatus-section__title-container-title">
              AWD Status
            </Typography>
          </div>
          {workQueueItemList?.map((workItem, idx) => (
            <div className="awdStatus-section__view-form-row">
              <DisplayPolicyNumber workQueueItemList={workItem} isQuality={props.isQuality} />
              <Grid container spacing={4}>
                <WorkTypeView
                  workType={workType}
                  workType2={workType2}
                  workType3={workType3}
                  workTypeList={workTypeList}
                  policyRecordWork={props.policyRecord.workType}
                  workItemList={workQueueItemList}
                  workTypeRowNo={idx}
                />

                <StatusView
                  status={status}
                  status2={status2}
                  status3={status3}
                  statusList={statusList}
                  policyRecordStatus={props.policyRecord.status}
                  workItemList={workQueueItemList}
                  statusTypeRowNo={idx}
                />

                <UnderWriterView
                  underwriter={underwriter}
                  underwriter2={underwriter2}
                  underwriter3={underwriter3}
                  underwriterList={underwriterList}
                  workItemList={workQueueItemList}
                  underWriterRowNo={idx}
                />

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedB"
                        color="secondary"
                        checked={override}
                        onChange={() => changeoverRide(idx)}
                      />
                    }
                    label={
                      <Typography className="awdStatus-section__checkbox-label">Override Beeline Approval</Typography>
                    }
                    key="OverrideBeeline"
                    className="awdStatus-section__view-form-text-field"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextareaAutosize
                    rowsMax={15}
                    rows={15}
                    aria-label="maximum height"
                    placeholder="Comments"
                    value={getComment(idx)}
                    onChange={e => changeComment(e.target.value, idx)}
                    id="awdStatus-comments"
                    className="awdStatus-section__view-form-comments"
                  />
                </Grid>
              </Grid>
            </div>
          ))}
          <div className="awdStatus-section_actions-container">
            <Button
              onClick={e => dispatch(AWDStatusActions.reset())}
              variant="contained"
              className="application-wizard__back-button"
            >
              Cancel
            </Button>
          </div>
        </form>
      </Container>
    </div>
  );
};

export default AWDStatusDashboard;
